import { render, staticRenderFns } from "./ViewPlan.vue?vue&type=template&id=133a97b2"
import script from "./ViewPlan.vue?vue&type=script&lang=js"
export * from "./ViewPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports